/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 案件資料功能頁面
 * @module CaseContainer
 */

// ----- import from local libraries -----
import {React} from '../../components/BaseComponent';

import {useEffect, useRef, useState} from 'react';
import {AlertModal} from 'web/components/modal/AlertModal';
// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import CasePage from './components/CasePage';
import ConditionModal from '../condition/components/ConditionModal';

import {useDispatch} from 'react-redux';
import {editConditionStatus} from '../../redux/actions/ConditionActions';
import enumList from '../../utils/enumList';
import ConditionListModal from '../condition/components/ConditionListModal';
import {useConditionListModalControl} from '../condition/hooks/useConditionListModalControl';
import {useConditionModalControl} from '../condition/hooks/useConditionModalControl';
import {useAlertModal} from 'web/components/modal/hooks/useAlertModal';

// ----- constants and enums -----

const CaseContainer = (props) => {
  const [needDispatchListLoad, setNeedDispatchListLoad] = useState(false);
  const dispatch = useDispatch();

  const {
    conditionList,
    dispatchModalRef,
    getConditionList,
    toggleDispatchListModal,
  } = useConditionListModalControl(setNeedDispatchListLoad);

  const {
    conditionModalMode,
    setConditionModalMode,
    conditionModalRef,
    toggleConditionModal,
  } = useConditionModalControl();
  const {
    toggleAlertModal,
    alertRef,
    actionType,
    actionMode,
    actionIds,
    alertMessage,
  } = useAlertModal();

  const handleEditConditionStatus = (conditionCodes, mode) => {
    dispatch(editConditionStatus({conditionCodes, flgStatus: mode}))
      .then((res) => {
        const statusCode = res.payload.code;
        if (statusCode && statusCode.isSuccessCode) {
          toggleAlertModal(false);
          getConditionList(true);
          // setTimeout(() => {
          //   getConditionList(true);
          // }, 100);
        } else {
          console.error('fetchEditConditionStatus error', res);
        }
      })
      .catch((err) => {
        showErrorMessage(enumList.messageModalMode.error, err);
        console.error('fetchEditConditionStatus error', err);
      });
  };

  const onConfirm = () => {
    const status =
      actionMode === enumList.alertModalModeEnums.enable
        ? enumList.flgStatus.active
        : enumList.flgStatus.inactive;
    if (actionType === enumList.targetAction.condition) {
      handleEditConditionStatus(actionIds, status);
    }
  };

  useEffect(() => {
    getConditionList();
  }, []);

  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <CasePage
            {...props}
            onDispatchList={() => {
              toggleDispatchListModal(true);
            }}
          />
        </div>
        <Footer />
      </div>

      <AlertModal
        ref={alertRef}
        mode={actionMode}
        message={alertMessage}
        onConfirm={() => onConfirm()}
        onCancel={() => {
          setNeedDispatchListLoad(true);
        }}
      />

      <ConditionModal
        {...props}
        ref={conditionModalRef}
        mode={conditionModalMode}
        onAddCondition={() => {
          toggleConditionModal(false);
          getConditionList();
        }}
      />

      <ConditionListModal
        {...props}
        ref={dispatchModalRef}
        conditionList={conditionList}
        needDispatchListLoad={needDispatchListLoad}
        setNeedDispatchListLoad={() => {
          setNeedDispatchListLoad(true);
        }}
        onEditConditionStatus={(mode, message, conditionCode) => {
          toggleAlertModal(
            true,
            mode,
            enumList.targetAction.condition,
            message,
            [conditionCode],
          );
          toggleDispatchListModal(false);
        }}
        onCondition={(mode = enumList.modalMode.new, conditionCode) => {
          toggleConditionModal(true, mode, conditionCode);
          toggleDispatchListModal(false);
        }}
      />
    </>
  );
};

export default CaseContainer;
